"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/subscriptionHint/subscriptionHint.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class SubscriptionHint extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(SubscriptionHint), "SubscriptionHint", []);
            this.TestDatas = SubscriptionHint.TestDatas;
            this.BindedLists = SubscriptionHint.BindedLists;
            this.BindedWidgets = SubscriptionHint.BindedWidgets;
            this.InitialData = SubscriptionHint.InitialData;
            this.path = SubscriptionHint.path;
            this.GeneratedConstructor = SubscriptionHint;
            if (SubscriptionHint.InitialData) {
                this.renderRecursive(SubscriptionHint.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.SubscriptionHint",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("div", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "subscription-hint-f47316" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "eyebrow" }] } }, [_t({ "templates": [{ "type": "raw", "content": "AI usage" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "message" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Unlock the full potential of Verset." }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "actions" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n        " }] }), _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "primary" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "openSubscription" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Subscribe" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n        " }] }), _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "later" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Later" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] })]), _t({ "templates": [{ "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = [{ "name": "default", "content": "", "json": {} }]; }
        static { this.BindedLists = []; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/subscriptionHint/subscriptionHint"; }
        static { this.widgetName = "SubscriptionHint"; }
        static { this.InitialData = null; }
    }
    R.SubscriptionHint = SubscriptionHint;
    SubscriptionHint["prototype"].widgetName = "SubscriptionHint";
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.subscription-hint-f47316 {\n\n    & {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        min-width: 0;\n    }\n\n    .eyebrow {\n        color: #8a847c;\n        font-size: 10px;\n        font-weight: 700;\n        letter-spacing: .1em;\n        line-height: 1.3;\n        text-transform: uppercase;\n    }\n\n    .message {\n        color: #272522;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1.5;\n    }\n\n    .actions {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 4px;\n        margin-top: 4px;\n    }\n\n    button {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        box-sizing: border-box;\n        height: 26px;\n        padding: 0 7px;\n        border: 1px solid transparent;\n        border-radius: 3px;\n        background: transparent;\n        color: #6f6961;\n        font: inherit;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1;\n        cursor: pointer;\n    }\n\n    button:hover {\n        background: #f4f3f1;\n        color: #272522;\n    }\n\n    .primary {\n        background: #111111;\n        border-color: #111111;\n        color: #ffffff;\n        font-weight: 600;\n    }\n\n    .primary:hover {\n        background: #33312e;\n        border-color: #33312e;\n        color: #ffffff;\n    }\n\n    button:focus-visible {\n        outline: 2px solid #8a847c;\n        outline-offset: 2px;\n    }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
